<template>
  <LsModal title="Pricing Issue?" track-id="turn_down_quote_modal_price">
    <template #body>
      <div class="columns">
        <div class="column">
          <p class="turn-down-quote-modal-price--text">Is the issue a pricing issue?</p>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="turn-down-quote-modal-price--button-wrapper">
        <LsButton
          class="turn-down-quote-modal-price--button"
          text="no"
          bg-color="primary-light"
          text-color="primary"
          track-id="turn_down_quote_modal_price-pricing_issue_yes"
          @click="next({ schedule_id: schedule_id, issues: { pricing: false } })"
        />
        <LsButton
          class="turn-down-quote-modal-price--button"
          text="yes"
          track-id="turn_down_quote_modal_price-pricing_issue_no"
          @click="next({ schedule_id: schedule_id, issues: { pricing: true } })"
        />
      </div>
    </template>
  </LsModal>
</template>

<script>
import VueTypes from 'vue-types';
import { LsModal, LsButton } from '@/components/common';
import { mapState } from 'vuex';

export default {
  name: 'TurnDownQuoteModalPrice',
  components: { LsModal, LsButton },
  props: {
    //eslint-disable-next-line vue/prop-name-casing
    schedule_id: VueTypes.number.isRequired,
    next: VueTypes.func.isRequired,
  },
  computed: {
    ...mapState(['schedules']),
  },
};
</script>

<style lang="scss" scoped>
.turn-down-quote-modal-price--text {
  min-height: 100px;
}
.turn-down-quote-modal-price--button-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.turn-down-quote-modal-price--button {
  margin: 4px;
}
</style>
